import { Theme } from '@mui/material/styles'

export const styles = {
  cardContainer: {
    minHeight: '142px',
  },

  dragIconContainer: {
    marginRight: (theme: Theme) => theme.spacing(1),
    marginLeft: (theme: Theme) => theme.spacing(1),
  },

  name: {
    width: '714px',
    color: '#1565c0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  description: {
    width: '714px',
    paddingBottom: (theme: Theme) => theme.spacing(0.3),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  label: {
    color: (theme: Theme) => theme.palette.text.primary,
  },

  menuContainer: {
    alignSelf: 'flex-start',
    marginTop: (theme: Theme) => theme.spacing(0.5),
    marginRight: (theme: Theme) => theme.spacing(2),
  },
}
